<script setup>
defineProps({
  mode: {
    type: String,
    default: 'list',
  },
})
</script>

<template>
  <div
    class="mx-auto flex max-w-full cursor-pointer flex-col items-center border-l-4 border-blue-500 bg-white text-sm shadow-md transition-all duration-200 hover:shadow-lg xl:max-w-md"
    :class="{
      'md:mx-0 md:max-w-none! md:flex-row': mode === 'list',
    }"
  >
    <div
      class="h-20 w-full"
      :class="{
        'flex-none md:flex md:h-16 md:w-80 md:items-center lg:w-96 2xl:w-2/5':
          mode === 'list',
      }"
    >
      <div
        class="mt-2 flex flex-1 items-center text-base font-bold"
        :class="{
          'md:mt-0': mode === 'list',
        }"
      >
        <slot />
      </div>
      <div class="ml-2 flex flex-none">
        <slot name="right" />
      </div>
    </div>

    <div
      class="my-2 hidden h-12 flex-none border-l-2 md:block"
      :class="{
        'md:hidden': mode !== 'list',
      }"
    />

    <div
      class="flex h-16 w-full flex-none items-center justify-between overflow-auto border-t-2 px-2"
      :class="{
        'md:w-auto md:flex-1 md:border-t-0': mode === 'list',
      }"
    >
      <slot name="metrics" />
    </div>
  </div>
</template>
